import { useLanguage } from "@/contexts/LanguageContext"

const ProcessSection = () => {
  const { t } = useLanguage()
  const steps = [
    { n: "01", title: t('process.brief'), desc: t('process.brief.desc') },
    { n: "02", title: t('process.match'), desc: t('process.match.desc') },
    { n: "03", title: t('process.realization'), desc: t('process.realization.desc') },
    { n: "04", title: t('process.review'), desc: t('process.review.desc') },
  ]
  return (
    <section id="process" className="py-24 md:py-32 bg-gradient-dark text-je-white relative overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-[0.07]" aria-hidden="true" />
      <div className="container-editorial relative">
        <div className="grid grid-cols-12 gap-8 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-5">
            <span className="eyebrow mb-5" style={{ color: 'hsl(var(--je-red))' }}>03 — Méthode</span>
            <h2 className="text-section-title font-serif font-medium mt-4 text-balance">{t('process.title')}</h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-lg text-je-white/70 text-pretty">{t('process.subtitle')}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-px bg-je-white/15">
          {steps.map((s) => (
            <div key={s.n} className="bg-je-navy p-8 lg:p-10 group">
              <div className="font-mono text-xs tracking-widest text-je-red mb-12">STEP {s.n}</div>
              <h3 className="font-serif text-3xl font-medium mb-4 leading-tight">{s.title}</h3>
              <p className="text-sm text-je-white/65 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
export default ProcessSection
